/**
 * 商品詳細 Quantity: 空欄（null）のとき 0 を表示
 */

const QUANTITY_INPUT_SELECTOR = "[data-js-quantity-input]";

function normalizeQuantityValue(input: HTMLInputElement): void {
  if (input.value === "" || input.value == null) {
    input.value = "0";
    input.dispatchEvent(new Event("change", { bubbles: true }));
  }
}

function initProductQuantityInput(input: HTMLInputElement): void {
  if (input.dataset.jsQuantityInputInitialized === "true") return;

  input.dataset.jsQuantityInputInitialized = "true";
  normalizeQuantityValue(input);
  input.addEventListener("blur", () => normalizeQuantityValue(input));
}

export function initProductQuantityAll(root: ParentNode = document): void {
  root
    .querySelectorAll<HTMLInputElement>(QUANTITY_INPUT_SELECTOR)
    .forEach(initProductQuantityInput);
}
